export default "__VITE_ASSET__Df8ka7hL__"